const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentBookingOverview.tsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import textMap from 'App/pages/appointment/translations';
import moment from 'moment/moment';
import React from 'react';
import { useIntl } from 'react-intl';
import { css } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';
import { Plan, Slot } from 'App/defs/types';

interface Props {
    slot: Slot;
    plan: Plan;
}

const cssDetails = css`
    margin-bottom: 12px;
`;

export const AppointmentBookingOverview = (props: Props) => {
    const { slot, plan } = props;

    const { formatMessage } = useIntl();

    const startDate = `${moment(slot.startDate).format('dddd, Do MMMM YYYY')}`;
    const startTime = `${moment(slot.startDate).format('HH:mm')}`;

    return (
        <>
            <Grid size={{ sm: 12 }}>
                <div className={cssDetails}>
                    <Typography variant={'body1'} sx={{ color: colors.grey['600'] }}>
                        {formatMessage(textMap.contactPerson)}
                    </Typography>
                    <Typography
                        variant={'body1'}
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >{`${plan.name}`}</Typography>
                </div>
                <div className={cssDetails}>
                    <Typography variant={'body1'} sx={{ color: colors.grey['600'] }}>
                        {formatMessage(textMap.date)}
                    </Typography>
                    <Typography
                        variant={'body1'}
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >
                        {startDate}
                    </Typography>
                </div>
                <div className={cssDetails}>
                    <Typography variant={'body1'} sx={{ color: colors.grey['600'] }}>
                        {formatMessage(textMap.time)}
                    </Typography>
                    <Typography
                        variant={'body1'}
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >
                        {formatMessage(textMap.timeFormat, { time: startTime })}
                    </Typography>
                </div>
            </Grid>
        </>
    );
};
